<template>
  <div>
    <h1>{{ $t("settings.workflow.title") }}</h1>
    <v-form ref="form">
      <v-tabs class="sub-menu md-3" slider-color="primary">
        <v-tab class="sub-menu-item" key="delegation-order">
          {{ $t("settings.workflow.delegationOrder") }}
        </v-tab>
        <v-tab class="sub-menu-item" key="delegation">
          {{ $t("settings.workflow.delegation") }}
        </v-tab>
        <v-tab-item class="mt-2" key="delegation-order">
          <workflow :workflow-data.sync="delegationOrderWorkflowData" />
        </v-tab-item>
        <v-tab-item class="mt-2" key="delegation">
          <workflow :workflow-data.sync="delegationWorkflowData" />
        </v-tab-item>
      </v-tabs>
    </v-form>
    <v-btn class="success" @click="saveDelegationOrderWorkflowSettings">{{ $t("global.save") }}</v-btn>
  </div>
</template>

<script>
import Workflow from "../../../components/Settings/Workflow";
export default {
  name: "SettingsWorkflowView",
  components: { Workflow },
  data: () => ({
    delegationOrderWorkflowData: {
      isCustomizedWorkflowEnabled: false,
      signAs: null,
      workflow: {}
    },
    delegationWorkflowData: {
      isCustomizedWorkflowEnabled: false,
      signAs: null,
      workflow: {}
    }
  }),
  created() {
    this.$store.dispatch("Settings/loadWorkflowData");
    this.getDelegationOrderWorkflowSettings();
  },
  computed: {
    users() {
      return this.$store.state.Settings.workflowData.users;
    }
  },
  methods: {
    getDelegationOrderWorkflowSettings() {
      this.axios.get("settings/workflow/get-settings").then(resp => {
        this.delegationOrderWorkflowData.workflow = resp.data.delegation_order.workflow_data;
        this.delegationOrderWorkflowData.isCustomizedWorkflowEnabled = resp.data.delegation_order.is_enabled;
        this.delegationOrderWorkflowData.signAs = resp.data.delegation_order.sign_as;
        this.delegationWorkflowData.workflow = resp.data.delegation.workflow_data;
        this.delegationWorkflowData.isCustomizedWorkflowEnabled = resp.data.delegation.is_enabled;
        this.delegationWorkflowData.signAs = resp.data.delegation.sign_as;
      });
    },
    saveDelegationOrderWorkflowSettings() {
      if (this.$refs.form.validate()) {
        this.axios
          .post("settings/workflow/save-settings", {
            delegation_order: {
              is_enabled: this.delegationOrderWorkflowData.isCustomizedWorkflowEnabled,
              workflow_data: this.delegationOrderWorkflowData.workflow,
              sign_as: this.delegationOrderWorkflowData.signAs
            },
            delegation: {
              is_enabled: this.delegationWorkflowData.isCustomizedWorkflowEnabled,
              workflow_data: this.delegationWorkflowData.workflow,
              sign_as: this.delegationWorkflowData.signAs
            }
          })
          .then(() => {
            this.$store.dispatch("snackbarPush", {
              text: this.$t("global.saved"),
              position: "down"
            });
          });
      }
    }
  }
};
</script>

<style scoped />
